import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class FormService extends BaseService {
    static async pending(routeContext) {
        const res = await this.get(`/forms/pending`, { route_context: routeContext }, "USER");
        return unwrapResponse(res);
    }
    static async submit(formId, answers, route) {
        const res = await this.post(`/forms/${formId}/responses`, { answers, route }, "USER");
        return unwrapResponse(res);
    }
}
